<template>
  <a-modal
    title="UpdateInfo"
    :width="1200"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('close')"
    :maskClosable='maskClosable'
    wrapClassName="ant-modal-cust-warp"
    style="top:5%;overflow-y: hidden">

    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-row :gutter="24">
          <a-col :md="12" :sm="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="Internal Group Name">
              <a-input placeholder="Please enterInternal Group Name" v-decorator="[ 'name', validatorRules.name]" readOnly/>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="Third-party Group Name">
              <a-input placeholder="Please enterThird-party Group Name" v-decorator="[ 'thirdName', validatorRules.thirdName]"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">
          <a-col :md="12" :sm="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="TaskQuantity">
              <a-input placeholder="Please enterTaskQuantity" v-decorator="[ 'num', validatorRules.num]"/>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="Info">
              <a-input placeholder="Please enterInfo" v-decorator="[ 'message', validatorRules.message]"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24">

          <a-col :md="12" :sm="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="Status">
              <a-select v-decorator="[ 'status', validatorRules.status]" :placeholder="$t('select') + 'Status'">
                <a-select-option v-for='item in statuses' :key='item.dictValue'>
                  {{item.dictTextCn}}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="12" :sm="12">
            <a-form-item
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
              label="Address">
              <a-input placeholder="Please enterAddress" v-decorator="[ 'path', validatorRules.path]"/>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="24" style='text-align: right' class="table-page-search-submitButtons">
          <a-button type="primary" @click="close" v-if='pageType=="detail"'>Close</a-button>
          <a-button type="primary" @click="handleOk" v-if='pageType=="edit"'>Save</a-button>
        </a-row>
      </a-form>
    </a-spin>
    <a-card style="margin-top: 24px" type="inner">
      <a-row :gutter="24">
        <a-card
          style="margin-top: 24px"
          title="Internal Action"
          type="inner"
          v-viewer="viewOptions">
          <a-card
            style="margin-top: 24px"
            title="StatusAction"
            type="inner"
            v-viewer="viewOptions" v-if='pageType == "edit"'>
            <div class="table-page-search-wrapper"><a-form layout="inline">
              <a-row :gutter="24">
                <a-col :md="24" :sm="24">
                  <a-form-item label="No Tax Filing Reason">
                    <a-input placeholder="Please enterNo Tax Filing Reason" v-model="errorMessage" :allowClear='allowClear' ></a-input>
                  </a-form-item>
                </a-col>
                <a-col :md="24" :sm="24">
                  <a-button type="primary" @click="noFilingTax">No Tax Filing</a-button>
                  <a-button type="primary" @click="close" >Close</a-button>
                </a-col>
                <a-col :md="24" :sm="24">
                  <a-divider style="height: 2px; background-color: #7cb305" v-if='oldStatus==10'/>
                  <a-button type="primary" @click="filingTaxSuccess" v-if='oldStatus==10'>Tax Filed Successfully</a-button>
                  <a-button type="primary" @click="close" v-if='oldStatus==10'>Close</a-button>
                </a-col>
              </a-row>
            </a-form></div>
          </a-card>
          <a-card
            style="margin-top: 24px"
            title="Post Tax Action"
            type="inner"
            v-viewer="viewOptions" v-if='pageType == "edit" && oldStatus==10'>
            <div class="table-page-search-wrapper"><a-form layout="inline">
              <a-row :gutter="24">
                <a-col :md="24" :sm="12">
                  <a-form-item
                    :labelCol="labelCol"
                    :wrapperCol="wrapperCol"
                    label="Upload Group Tax Filing File">
                    <a-button type="primary" icon="upload" :loading="loading" @click='uploadTaxFile'>Upload Group Tax File</a-button>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form></div>
          </a-card>
        </a-card>
      </a-row>
    </a-card>
    <a-modal
      title="Import"
      :visible="visible1"
      :confirm-loading="loading"
      @ok="onUploadFile"
      @cancel="visible1 = false"
      :width="500"
    >
      <a-form>
        <a-form-item>
          <a-upload name="file" :multiple="true" :before-upload="beforeUpload" :remove="(file = null)">
            <a-button> <a-icon type="upload" /> Select File </a-button>
          </a-upload>
        </a-form-item>
      </a-form>
    </a-modal>
  </a-modal>
</template>

<script>
import pick from 'lodash/pick'
import {
  filingTaxGroupDetail,
  filingTaxGroupUpdate,
  filingTaxGroupUpdate1,
  uploadTaxResultFile
} from '@/webpublicapi/order'
import imageMixin from '@/mixins/image-mixin';
export default {
  name: "OrderFilingTaxGroupUpdateModel",
  props: {
    oldErrorMessage: {
      type: String,
      default: null,
    },
    statuses: {
      type: Array,
      default: []
    },
    groupId: {
      type: Number,
      default: null,
    },
    pageType: {
      type: String,
      default: null
    },
  },
  mixins: [imageMixin],
  data () {
    return {
      title:"Action",
      visible: false,
      visible1: false,
      allowClear: true,
      loading: false,
      readOnly: true,
      file: null,
      fileList:[],
      imageLoading:[],
      imgCount: 0,
      visibleUploadtax: false,
      orderIdForTax: null,
      oldStatus: '',
      model: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      // imageInfos: [],
      id: null,
      errorMessage: '',
      confirmLoading: false,
      maskClosable: false,
      form: this.$form.createForm(this),
      validatorRules:{
        name:{
          rules: [
            { required: true, message: 'Please input name!' },
          ]},
        thirdName:{
          rules: [
            { required: false, message: 'Please input thirdName!' },
          ]},
        num:{
          rules: [
            { required: true, message: 'Please input num!' },
          ]},
        message:{
          rules: [
            { required: false, message: 'Please input message!' },
          ]},
        path:{
          rules: [
            { required: false, message: 'Please input path!' },
          ]},
        status:{
          rules: [
            { required: true, message: 'Please select status!' },
          ]},
      },
    }
  },
  created () {
  },
  methods: {
    edit (record) {
      this.form.resetFields();
      this.open();
      this.model = Object.assign({}, record)
      this.id = record.id
      this.oldStatus = record.status
      this.$nextTick(() => {
        this.form.setFieldsValue(pick(this.model,'name', 'thirdName', 'num', 'message', 'status', 'path'))
      });
      // this.detail(record.id);
      this.errorMessage = ''
      // this.fillCurStatus();
    },
    // fillCurStatus() {
    //   document.getElementById('curStatus').value = this.showCurStatus()
    // },
    // detail(id) {
    //   this.imageInfos=[];
    //   var model= {
    //     'id': id
    //   }
    //   filingTaxGroupDetail(model).then((res) => {
    //     if (res.code === 1000) {
    //       this.imageInfos = res.data.imageInfos
    //     } else {
    //       this.$message.error(res.msg)
    //     }
    //   }).catch(e => {
    //     this.$message.error(e.message);
    //   })
    // },
    open () {
      this.visible = true;
    },
    close () {
      this.$emit('close');
      this.visible = false;
    },
    openLoading () {
      this.confirmLoading = true;
    },
    closeLoading () {
      this.confirmLoading = false;
    },
    showCurStatus() {
      for (const st in this.statuses) {
        if(this.statuses[st].dictValue == this.oldStatus) {
          return this.oldStatus+"-"+this.statuses[st].dictTextCn;
        }
      }
    },
    handleOk () {
      if("detail" === this.pageType) {
        this.close();
        return;
      }
      const that = this;
      // Trigger form validation
      this.form.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true;
          let formData = {
            ...values,
          }
          this.$emit('ok', formData);

        }
      })
    },
    noFilingTax() {
      var model = {
        id: this.id,
        status: '3',
        message: this.errorMessage
      }
      filingTaxGroupUpdate1(model).then(res => {
        if (res.code === 1000) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      })
    },
    filingTaxSuccess() {
      var model = {
        id: this.id,
        status: '4'
      }
      filingTaxGroupUpdate1(model).then(res => {
        if (res.code === 1000) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      }).catch(e => {
        this.$message.error(e.message);
      })
    },
    handleCancel () {
      this.close()
    },
    // uploadtax() {
    //   this.visibleUploadtax = true;
    //   this.orderIdForTax = this.id;
    // },
    // remove(file) {
    //   // console.log(file)
    //   var newList = [];
    //   for(var item in this.fileList){
    //     var theFile = this.fileList[item];
    //     if(theFile.attCode === file.response.data.attachmentCode) {
    //       continue;
    //     }
    //     newList.push(theFile);
    //   }
    //   this.fileList = newList;
    //   // console.log(newList)
    //   return true;
    // },
    // customRequest(file){
    //   const form = new FormData();
    //   var theCount = this.imgCount;
    //   this.imgCount = this.imgCount + 1;
    //   this.imageLoading[Number(theCount)] = 'loading'
    //   form.append('file', file.file)
    //   uploadTax(form, this.orderIdForTax).then(res => {
    //     if (res.code === 1000) {
    //       file.onSuccess(res, file.file)
    //       file.status = 'done'
    //       this.imageLoading[Number(theCount)] = 'done';
    //       this.$message.info("success")
    //       file['attCode'] = res.data.attachmentCode
    //       this.fileList.push(file);
    //       // console.log(file)
    //     } else {
    //       file.onError()
    //       file.status = 'error'
    //       this.imageLoading[Number(theCount)] = 'done';
    //       this.$message.error(res.msg)
    //     }
    //   }).catch(e => {
    //     file.onError()
    //     file.status = 'error'
    //     this.imageLoading[Number(theCount)] = 'done';
    //     this.$message.error(e.message);
    //   })
    // },
    uploadTaxFile() {
      this.visible1 = true
    },
    beforeUpload(file) {
      this.file = file
      return false
    },
    onUploadFile() {
      if (!this.file) {
        this.$message.error('Please select file')
        return
      }

      this.loading = true

      let formData = new FormData() //PassformdataUpload
      formData.append('file', this.file)
      formData.append('id', this.groupId)
      uploadTaxResultFile(formData)
        .then((res) => {
          if (res) {
            this.$message.success('UploadSuccess')
            this.visible1 = false

            // exportFile(res.data, res.fileName)
          } else {
            this.$message.error(res.msg)
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  }
}
</script>

<style scoped>

</style>